import { ethers } from "ethers";
import { contractABI, contractAddress } from "./contractUtils";
import { handleAlert } from "./alertUtil";

export const checkIfWalletIsConnected = async (
  setCurrentAccount,
  setData,
  handleAlert,
  setAlertInfo
) => {
  try {
    const { ethereum } = window;

    if (!ethereum) {
      handleAlert("Make sure you have metamask!", "#0f5200");
      console.log("Make sure you have metamask!");
      return;
    } else {
      console.log("We have the ethereum object", ethereum);
    }

    const accounts = await ethereum.request({ method: "eth_accounts" });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account:", account);
      setCurrentAccount(account);
      loadData(setData, handleAlert, setAlertInfo);
    } else {
      console.log("No authorized account found");
    }
  } catch (error) {
    console.log(error);
  }
};

export const wave = async (setAlertInfo, message, setData) => {
  try {
    const { ethereum } = window;

    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const waveportalContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );

      /*
       * Wave Now
       */
      const waveTxn = await waveportalContract.wave(message, {
        gasLimit: 300000,
      });
      console.log("Mining...", waveTxn.hash);

      setAlertInfo({
        amessage: "Mining in progress... ⛏",
        acolor: "#daed0c",
        show: true,
      });
      await waveTxn.wait();
      handleAlert("Mining Completed! 🛠", "#09b812", setAlertInfo);
      console.log("Mined -- ", waveTxn.hash);
    } else {
      handleAlert("Ethereum object doesn't exist!", "#f56c42");
      console.log("Ethereum object doesn't exist!");
    }
  } catch (error) {
    console.log(error);
  }
};

export const loadData = async (setData, handleAlert, setAlertInfo) => {
  try {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const wavePortalContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );

      const waves = await wavePortalContract.getAllWaves();

      let wavesCleaned = [];
      waves.forEach((wave) => {
        wavesCleaned.unshift({
          address: wave.waver,
          timestamp: new Date(wave.timestamp * 1000).toString(),
          message: wave.message,
        });
      });

      setData([...wavesCleaned]);

      wavePortalContract.on("NewWave", (from, timestamp, message) => {
        console.log("NewWave", from, timestamp, message);

        setData((prevState) => [
          {
            address: from,
            timestamp: new Date(timestamp * 1000).toString(),
            message: message,
          },
          ...prevState,
        ]);
      });
    } else {
      handleAlert("Ethereum object doesn't exist!", "##d90404", setAlertInfo);
      console.log("Ethereum object doesn't exist!");
    }
  } catch (error) {
    handleAlert("Connect to wallet!", "#d90404", setAlertInfo);
    console.log(error);
  }
};
